import { BeneficialOwnerPartyForm } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/BeneficialOwnerPartyForm";
import { OtherRelatedPartyForm } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/OtherRelatedPartyForm";
import { RelationType } from "Infrastructure/Api/Api";
import type { PartyDto } from "Infrastructure/Api/Api";

type Props = {
  relationType: RelationType;
  partyData: PartyDto;
  isOwner: boolean;
  onSaveSuccess?: () => void;
};

export const RelatedPartyForm = ({
  relationType,
  partyData,
  isOwner,
  onSaveSuccess,
}: Props) => {
  const isRelatedPartyOwner = relationType === RelationType.BeneficialOwner;

  if (isRelatedPartyOwner) {
    return (
      <BeneficialOwnerPartyForm
        partyData={partyData}
        onSaveSuccess={onSaveSuccess}
      />
    );
  }

  return (
    <OtherRelatedPartyForm
      isOwner={isOwner}
      partyData={partyData}
      relationType={relationType}
      onSaveSuccess={onSaveSuccess}
    />
  );
};
